import { defineStore } from 'pinia';
import { useInfo } from '@/store';
import audio from '../common/audio';

type FloatText = {
  show: boolean;
  top: number;
  left: number;
  text: string;
};
type Toast = {
  show: boolean;
  keepAlive: boolean;
  text: string;
};

interface GeneralState {
  // floatText
  floatText: FloatText;
  // Toast
  toast: Toast;
}

const generalState = (): GeneralState => ({
  // floatText
  floatText: {
    show: false,
    top: 0,
    left: 0,
    text: '',
  },
  // Toast
  toast: {
    show: false,
    keepAlive: false,
    text: '',
  },
});

const useGeneral = defineStore('general', {
  state: generalState,
  actions: {
    handleError(errCode: string) {
      this.handleToast(true, errCode, true);
      // addGA("msgError", errCode);
    },
    handleToast(showToast: boolean, text = '', keepAlive = false) {
      const { translations } = useInfo();
      this.$patch({
        toast: {
          ...this.toast,
          show: showToast,
          keepAlive: keepAlive
        }
      })
      if (this.toast.show) {
        this.toast.text = (translations && translations[text]) || text;
        audio.toast.play();
      }
    },
    updateFloatText(updateValue: Partial<FloatText>) {
      this.floatText = {
        ...this.floatText,
        ...updateValue
      };
    }
  },
});

export default useGeneral;
